import Swiper, { Navigation } from 'swiper';

//Menu filters slider
let sliderFilters = new Swiper(document.getElementById('catalog-categories-filter'), {
    slidesPerView: 'auto',
    spaceBetween: 0,
    freeMode: true,
});

document.addEventListener('DOMContentLoaded', function (e) {
    let containerFilter = document.getElementById('container-filter');
    let beforeCards = document.getElementById('separator-catalog');
    let width = window.innerWidth;

    // scroll top
    document.querySelectorAll('.category-filter').forEach(function (item) {
        item.addEventListener('click', function (e) {
            if (item.closest('#container-filter').classList.contains('is-sticky')) {
                let top = beforeCards.offsetTop + 4;

                window.scrollTo({
                    top: top,
                    behavior: 'smooth'
                })
            }
        })
    })

    function scrollStickyMenu() {
        if (window.pageYOffset > beforeCards.offsetTop) { //sticky
            containerFilter.classList.add('is-sticky');
            containerFilter.style.top = '-200px';
            containerFilter.style.transform = 'translateY(200px)';
            document.querySelector('.catalog-categories-filter-container').style.transform = 'translate(0px, 0px) translateZ(0px)';
        } else { //not sticky
            if (containerFilter.classList.contains('is-sticky')) {
                containerFilter.style.transform = 'translateY(-200px)';
                containerFilter.removeAttribute("style");
                beforeCards.removeAttribute("style");
                containerFilter.classList.remove('is-sticky', 'open');
                filterResults();
            }
        }
    }

    // sticky filter
    function menuSticky(width) {
        let toggleStickyFilter = document.getElementById('toggle-filter-sticky');

        if (width < 1200) {
            document.addEventListener('scroll', scrollStickyMenu);

            if (window.pageYOffset > beforeCards.offsetTop) { //sticky
                containerFilter.classList.add('is-sticky');

                containerFilter.style.top = '-200px';
                containerFilter.style.transform = 'translateY(200px)';
                document.querySelector('.catalog-categories-filter-container').style.transform = 'translate(0px, 0px) translateZ(0px)';
            }

            toggleStickyFilter.addEventListener('click', function () {
                if (!containerFilter.classList.contains('open')) {
                    containerFilter.classList.add('open');
                    beforeCards.style.height = containerFilter.clientHeight + 'px';
                } else {
                    containerFilter.classList.remove('open');
                    beforeCards.removeAttribute("style");
                }
            })
        } else {
            if (containerFilter.classList.contains('is-sticky')) {
                containerFilter.style.transform = 'translateY(-200px)';
                containerFilter.removeAttribute("style");
                beforeCards.removeAttribute("style");
                containerFilter.classList.remove('is-sticky', 'open');

                document.removeEventListener('scroll', scrollStickyMenu);
            }
        }
    }


    window.addEventListener('resize', () => {
        if (window.innerWidth != width) {
            width = window.innerWidth;
            if (width >= 1200) {
                menuSticky(width);
            }
        }
    })

    menuSticky(width);
    //end sticky filter

    //list filter results
    const filterResults = () => {
        if (document.querySelector('.filter-menu-list') !== ('undefined' && null)) {
            let filterContainer = document.getElementById('content-filter');

            let filterResultsContainer = document.querySelector('.filter-menu-list');
            let filterResultsCount = document.querySelectorAll('.ingredient-list-item').length;
            let height = filterResultsContainer.clientHeight;
            //console.log(height)
            //console.log(filterContainer)
            filterContainer.style.marginBottom = height + 'px';
        }
    }

    window.addEventListener('update-filter-results', event => {
        filterResults();
    })

    filterResults();

});
